(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[444],{

/***/ "ak2Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cross", function() { return Cross; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Cross = function Cross(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M23.0282818,3.55581844 L14.8923617,11.6949684 L6.75002775,3.55581844 C6.32236395,3.12820045 5.75542881,2.89496677 5.15298864,2.89496677 C4.54871595,2.89334041 3.98017736,3.12820045 3.55100173,3.5574448 C2.6714849,4.44026016 2.6714849,5.87535053 3.55262809,6.75633338 L11.6918697,14.8954604 L3.54937537,23.0380234 C3.1250101,23.4622512 2.89177642,24.0291864 2.89015006,24.6334591 C2.89177642,25.2375027 3.12663646,25.8060413 3.55100173,26.2304982 C3.98017736,26.6597654 4.54871595,26.8945568 5.15138519,26.8945568 C5.75703226,26.8945568 6.3239674,26.6613689 6.75323466,26.2321016 L14.8907582,18.0945781 L23.0298853,26.2337051 C23.9094937,27.1130845 25.3461876,27.111481 26.2287739,26.2321016 C26.6564377,25.8044378 26.8930615,25.2375027 26.8946649,24.6334591 C26.8930615,24.0291864 26.6580411,23.4606478 26.2303773,23.03642 L18.0912503,14.893857 L26.2287739,6.75633338 C26.6564377,6.32546267 26.8930615,5.75875659 26.8930615,5.15608736 C26.8930615,4.55364719 26.6548342,3.9851086 26.2255669,3.55258862 C25.3445841,2.67467524 23.9094937,2.67467524 23.0282818,3.55581844"
  }));
};

/***/ })

}]);